import { render, staticRenderFns } from "./ActivityWsImageCarousel.vue?vue&type=template&id=94e5fd58&scoped=true"
import script from "./ActivityWsImageCarousel.vue?vue&type=script&lang=ts"
export * from "./ActivityWsImageCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsImageCarousel.vue?vue&type=style&index=0&id=94e5fd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5fd58",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWsImageCarousel.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports